import axios from "axios";
// import { setAlert } from './alert';

import {
  GET_USERS,
  GET_MESSAGES,
  ADD_MESSAGE,
  MESSAGE_ERROR,
  CLEAR_MESSAGES,
  CLEAR_USERS,
  DELETE_MESSAGE,
  DELETE_CONVERSATION,
  DELETE_MESSAGES,
} from "./types";

// Get messages by ID
export const getMessagesById = () => async (dispatch) => {
  try {
    const res = await axios.get(`/api/message/user_messages`);

    dispatch({
      type: GET_MESSAGES,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: MESSAGE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get users to message
export const getUsers = (textValue) => async (dispatch) => {
  const formData = new FormData();
  formData.append("text", JSON.stringify(textValue));

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(`/api/message`, formData, config);

    dispatch({
      type: GET_USERS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: MESSAGE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Create a new message
export const createMessage = (textMessage, recipient) => async (dispatch) => {
  const formData = new FormData();
  formData.append("message", JSON.stringify(textMessage));
  formData.append("recipient", JSON.stringify(recipient));

  if (textMessage.media !== "") {
    formData.append("media", textMessage.media);
  }

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/create_message`, formData, config);

    dispatch({
      type: ADD_MESSAGE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: MESSAGE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Delete text message
export const deleteMessage = (_id, user) => async (dispatch) => {
  const formData = new FormData();
  formData.append("_id", JSON.stringify(_id));
  formData.append("user", JSON.stringify(user));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(
      `/api/message/delete_message`,
      formData,
      config
    );

    dispatch({
      type: DELETE_MESSAGE,
      payload: res.data,
    });

    // dispatch(setAlert("Message Deleted"));
  } catch (err) {
    dispatch({
      type: MESSAGE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Delete a conversation
export const deleteConversation = (user) => async (dispatch) => {
  const formData = new FormData();
  formData.append("user", JSON.stringify(user));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(
      `/api/message/delete_conversation`,
      formData,
      config
    );

    dispatch({
      type: DELETE_CONVERSATION,
      payload: res.data,
    });

    // dispatch(setAlert("Message Deleted"));
  } catch (err) {
    dispatch({
      type: MESSAGE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Delete all messages
export const deleteAllMessages = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/message/delete_messages`);

    dispatch({
      type: DELETE_MESSAGES,
      payload: res.data,
    });

    // dispatch(setAlert("Message Deleted"));
  } catch (err) {
    dispatch({
      type: MESSAGE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Clear Messages Users Search

export const clearUsers = () => async (dispatch) => {
  dispatch({ type: CLEAR_USERS });
};
